module.exports = __webpack_public_path__ + "static/img/collection-tag.cdd06da9.svg";